import React, { CSSProperties } from "react";
import style from "./snippet.module.scss";
import { Button } from "../button/button";
import { Icons } from "shared/ui";
import cx from "classnames";
import { copyText } from "../../lib/copy-text";
import toast from "react-hot-toast";

interface ISnippet {
  text: React.ReactNode;
  width?: number | string;
  style?: CSSProperties;
  className?: string;
  type?: "lite" | "secondary" | "success" | "error" | "warning";
  fill?: boolean;
}

export const Snippet = (props: ISnippet) => {
  const onCopy = (value: React.ReactNode) => {
    copyText(value as string)
      .then((reps) => {
        toast.success("Ссылка скопирована", { duration: 1000 });
      })
      .catch((e) => {
        toast.error(e, { duration: 1000 });
      });
  };

  return (
    <div
      className={cx(
        style.snippet,
        props.type === "lite" && props.fill ? style.lite_fill : props.type === "lite" && style.lite,
        props.type === "secondary" && props.fill ? style.secondary_fill : props.type === "secondary" && style.secondary,
        props.type === "success" && props.fill ? style.success_fill : props.type === "success" && style.success,
        props.type === "error" && props.fill ? style.error_fill : props.type === "error" && style.error,
        props.type === "warning" && props.fill ? style.warning_fill : props.type === "warning" && style.warning,

        props.fill && style.fill,
        props.className
      )}
      style={{ ...props.style, width: props.width }}
    >
      <p className={style.text}>{props.text}</p>
      <button className={style.button} onClick={() => onCopy(props.text)}>
        {<Icons.Copy />}
      </button>
    </div>
  );
};

Snippet.defaultProps = {};
